import React from 'react';
import PropTypes from 'prop-types';
import { bem } from 'helpers/class-name';
import './ButtonGroup.scss';

const { block, element } = bem('button-group');

const ButtonGroup = props => {
  const { className, flush, children, ...rest } = props;

  return (
    <div {...rest} className={block(className, { flush })}>
      {React.Children.map(children, child =>
        React.isValidElement(child)
          ? React.cloneElement(child, {
              className: element('child', child.props.className),
            })
          : child
      )}
    </div>
  );
};

ButtonGroup.propTypes = {
  className: PropTypes.string,
  flush: PropTypes.bool,
  children: PropTypes.node,
};

export default ButtonGroup;
